import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import ProfileTab from './ProfileTab';
import SalarySlipDialog from './SalarySlipDialog';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AllProfilesTab({ currentUser }) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [salarySlipUser, setSalarySlipUser] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        setUsers(response.data.data.users);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      toast.error('Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  if (selectedUser) {
    return (
      <div>
        <button
          onClick={() => setSelectedUser(null)}
          style={{
            background: '#e2e8f0',
            color: '#2d3748',
            padding: '0.5rem 1rem',
            borderRadius: '0.5rem',
            border: 'none',
            cursor: 'pointer',
            fontWeight: '600',
            marginBottom: '1rem'
          }}
          data-testid="back-to-users-btn"
        >
          ← Back to All Users
        </button>
        <ProfileTab user={selectedUser} currentUser={currentUser} form="admin" />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="empty-state" data-testid="users-loading">
        <p>Loading users...</p>
      </div>
    );
  }

  return (
    <div data-testid="all-profiles-tab">
      <h2
        style={{
          fontSize: "1.5rem",
          fontWeight: "700",
          marginBottom: "1.5rem",
        }}
      >
        All User Profiles
      </h2>

      {users.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <table className="data-table" data-testid="all-users-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Joining Date</th>
                <th>Earned Leaves</th>
                <th>Total Taken</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} data-testid={`user-profile-row-${user.id}`}>
                  <td data-testid={`user-profile-name-${user.id}`}>
                    {user.name}
                  </td>
                  <td>{user.email}</td>
                  <td>
                    <span
                      className="status-badge"
                      style={{ background: "#e6f2ff", color: "#0066cc" }}
                    >
                      {user.role}
                    </span>
                  </td>
                  <td>
                    {new Date(user.joining_date).toLocaleDateString("en-IN")}
                  </td>
                  <td>{user.earned_leaves.toFixed(1)}</td>
                  <td>
                    {(
                      user.sick_leaves_taken + user.casual_leaves_taken
                    ).toFixed(1)}
                  </td>
                  <td
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "8px",
                      justifyContent:
                        user.role === "admin" ? "center" : "flex-start",
                    }}
                  >
                    <button
                      onClick={() => setSelectedUser(user)}
                      className="action-btn"
                      style={{ background: "#667eea", color: "white" }}
                      data-testid={`view-profile-btn-${user.id}`}
                    >
                      View Profile
                    </button>

                    {user.role !== "admin" && (
                      <button
                        onClick={() => setSalarySlipUser(user)}
                        className="action-btn"
                        style={{ background: "#667eea", color: "white" }}
                        data-testid={`gen-salary-slip-btn-${user.id}`}
                      >
                        Gen Salary Slip
                      </button>
                    )}
                  </td>
                  {salarySlipUser && (
                    <SalarySlipDialog
                      user={salarySlipUser}
                      onClose={() => setSalarySlipUser(null)}
                    />
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="empty-state" data-testid="no-users-found">
          <p>No users found</p>
        </div>
      )}
    </div>
  );
}

export default AllProfilesTab;